import type { Consultant } from '#shared/types';
import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<Consultant>[] = [
  { key: 'name', header: 'Name', render: (row) => <strong>{row.name}</strong> },
  { key: 'designation', header: 'Designation', render: (row) => row.designation },
  { key: 'qualifications', header: 'Qualifications', render: (row) => row.qualifications },
  {
    key: 'registration_no',
    header: 'Registration',
    width: '150px',
    render: (row) =>
      row.registration_no ? (
        <span className="ident">{row.registration_no}</span>
      ) : (
        <span className="text-fg-muted">—</span>
      ),
  },
  {
    key: 'is_active',
    header: 'Status',
    width: '110px',
    render: (row) =>
      row.is_active ? <Badge tone="success">Active</Badge> : <Badge tone="neutral">Retired</Badge>,
  },
];

export function ConsultantListPage() {
  return (
    <ResourceListPage<Consultant>
      title="Reporting doctors"
      subtitle="Whose name and signature go on a released report"
      path={RESOURCE.consultants}
      columns={columns}
      noun="consultant"
      nounPlural="consultants"
      searchPlaceholder="Search by name, designation or registration"
      rowLabel={(row) => row.name}
      createCapability="consultant.create"
      editCapability="consultant.edit"
      deleteCapability="consultant.delete"
      emptyBody="A consultant signs reports but does not sign in — they need no staff account."
    />
  );
}
